import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';
import { CircularProgress, Tooltip, Typography } from '@mui/material';

import { DatalineStatus } from 'src/constants/dataline';
import useSurveySettings from 'src/hooks/useSurveySettings';

import { styles } from './index.styles';

export interface ReturnsProps {
  count: number | null;
  returnState: DatalineStatus;
  invalidities: boolean | string[];
}

const Returns: FC<ReturnsProps> = ({
  count = null,
  returnState = DatalineStatus.STATUS_LOADING,
  invalidities,
}) => {
  const { t } = useTranslation(['workspace', 'report']);
  const { minRespondentAmount } = useSurveySettings();

  return (
    <div>
      {returnState === DatalineStatus.STATUS_OK &&
        count !== null &&
        `n = ${count}`}
      {returnState === DatalineStatus.STATUS_TOO_FEW_NUMBER_OF_CASES && (
        <Typography
          component="span"
          sx={styles.toFew}
        >{`n < ${minRespondentAmount}`}</Typography>
      )}
      {returnState === DatalineStatus.STATUS_AVOID_NEGATIVE_SELECTION && (
        <Tooltip title={t('workspace:missingOrgUnitWarning')}>
          <WarningAmberRounded />
        </Tooltip>
      )}
      {(returnState === DatalineStatus.STATUS_ERROR ||
        (returnState === DatalineStatus.STATUS_OK && count === null)) && (
        <Tooltip title={t('workspace:notAvailable')}>
          <WarningAmberRounded />
        </Tooltip>
      )}
      {returnState === DatalineStatus.STATUS_LOADING && !invalidities && (
        <CircularProgress size={20} />
      )}
      {returnState === DatalineStatus.STATUS_LOADING &&
        Array.isArray(invalidities) &&
        invalidities.length && (
          <Tooltip
            title={
              Array.isArray(invalidities)
                ? invalidities
                    .map((error) => t(`report:errorMessages.${error}`))
                    .join('\n')
                : undefined
            }
          >
            <WarningAmberRounded />
          </Tooltip>
        )}
    </div>
  );
};

export default Returns;
